import { render, staticRenderFns } from "./poster-2.vue?vue&type=template&id=2637a406&scoped=true&"
import script from "./poster-2.vue?vue&type=script&lang=js&"
export * from "./poster-2.vue?vue&type=script&lang=js&"
import style0 from "./poster-2.vue?vue&type=style&index=0&id=2637a406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2637a406",
  null
  
)

export default component.exports